import { NEW_BOARD_PENDING_ID } from '../constants';

export const isPendingBoardId = (id: number): id is -999 =>
  id === NEW_BOARD_PENDING_ID;
